import { yupResolver } from '@hookform/resolvers/yup'
import {
    first,
    flatten,
    has,
    isArray,
    isEmpty,
    isMatch,
    isUndefined,
    omit,
    pick,
} from 'lodash'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import ImageGallery from 'react-image-gallery'
import { useStep } from 'usehooks-ts'
import { Container } from '../../components/Container'
import Header from '../../components/Header'
import { CsvStore, getProductFiles } from '../../state/CsvStore'
import { Stepper, Step } from '../../components/Stepper'
import {
    singleProductRules,
    isSimpleProduct,
    getPrice,
    getTotalSteps,
    LeadFieldName,
    getStepsAndFields,
    getProductImages,
    getMinQuantity,
    shouldChangeTotalSteps,
    totalStepsForMultiTouch,
    getMaxLength,
    shouldAddShipping,
    getNoOfShippingFee,
    isMultiTouchProduct,
    // generateMultiTouchValuesForVariationToSelect,
    currentTouchesValue,
    isCampaignProduct,
    processAddToCart,
    handleDesignOnFile,
    getshippingFieldName,
    handleShouldDeleteMetasAndValueChange,
    preprareWithLogoArrayString,
    customizeMailPieceField,
    noOfRecordsField,
    hasLeadFileInput,
    hasSetNoOfRecordsManually,
    handleManuallySetNoOfRecords,
    purchaseField,
    logoField,
    templateField,
    defaultCustomizationTemplateFieldName,
    AttributesFieldName,
    designMyFileFieldName,
    selectTemplateField,
    shouldFollowNewOrderProcess,
    isPostageField,
    getPostageField,
    isPostcardSizeField,
    mayBeConvertTemplateURLToATag,
    isPurchaseListField,
    mappingListGroupField,
    leadField,
    MappedFieldName,
    selectPreviouslyDesignedFileFieldName,
    orderNoForDesignFieldName,
    duplicatePreviousOrderFieldName,
    mailerKeyName,
    isCYOProduct,
    calculateCYOPricingBasedOnProducts,
    filterMaileTypesFromGetValues,
    shouldAddShippingCampaignProduct,
    realPennedAdditionalFields,
    extractMailerNumber,
    chooseFromGalleryOptionName,
    previsoulyDesignedFileFieldName,
    MAILERS_QUANTITY_METAKEY,
    TOTLAMAILERS_METAKEY,
    ACTUAL_QUANTITY_METAKEY,
    getTieredPrice,
    postageFieldName,
    standardClassPostage,
    appearanceFieldNames,
    rosField,
    customerHasListOptionValue,
    customerHasNoListOptionValue,
    pagesAndPrintingField,
    shouldAddPagesAndPrinting,
    postcardSizeFieldName,
    streetviewImageFieldName,
    streetviewYesOptionValue,
    isStreetviewTemplateName,
    handWritingFieldName,
    // addToServerCart,
    isRealPennedEnvelopeField,
    isRealPennedProfessionalLetterProduct,
    isRealPennedLetterProduct,
} from '../../helpers/slug'
// import { NoticeStore } from '../../state/NoticeStore'
import {
    convertFilesTobase64,
    extractFilenamesFromURL,
    getErrorMessage,
    getHrefsFromNavigationsForPaths,
    log,
    log2,
    ParseWordPressHTML,
    showWentWrongModal,
} from '../../helpers/utils'
import CartInfo, { CYOCartInfo } from '../../components/Product/CartInfo'
import { AddToCartButton } from '../../components/Product/AddToCartButton'
import { HeadingText } from '../../components/Product/HeadingText'
import {
    AddOnProducts,
    pagesAndPrintingVariationErrorMessage,
} from '../../state/AddOnProductStore'
import produce from 'immer'
import DevTool from '../../components/DevTool'
import { useRouter } from 'next/router'
import Loader from '../../components/Loader'
import { ShowField } from '../../components/Product/ShowField'
import { _CAMPAIGN_PRICE_KEY } from '../../helpers/checkout'

import fs from 'fs'
import path from 'path'
import { ThoughtMetrics } from '../../helpers/ThoughtMetrics'
import { EcomAPI } from '../../apis/Ecom'
import { OrderAPI } from '../../apis/OrderAPI'
import { UserStore } from '../../state/UserStore'
import { ModalStore } from '../../state/ModalStore'
import SelectTemplateModal from '../../components/Modals/SelectTemplateModal'
import { ContainerWrapper } from '../../components/Container'
import HomepageBookCallLeadModal from '../../components/Modals/HomepageBookCallLeadModal'
import {
    ADMIN_UPLOAD_FILES,
    CLIENT_ROS_FILE,
    REUPLOAD_DELIVERABLE_FILES,
    REUPLOAD_ORIGINAL_FILES,
} from '../../helpers/contants'
const mailingListTemplateUrl =
    'https://admin.openlettermarketing.com/wp-content/uploads/2023/11/OLM-Lead-Template.csv'

const personalLettersFaqs = [
    {
        question: 'Do the letters actually look handwritten?',
        answer: (
            <>
                The body uses one of six handwriting-style fonts and the
                envelope is addressed in the same style, paired with a real live
                stamp. It reads as personal mail. If you&apos;re looking for a
                genuinely handwritten letter, see our{' '}
                <a
                    href="https://openlettermarketing.com/product/real-penned-letters"
                    className="font-bold text-[#ED5C2F]">
                    Real Penned Letters
                </a>
                .
            </>
        ),
    },
]

const personalLettersReviews = [
    {
        initials: 'DM',
        name: 'Derek M.',
        role: 'Marketing Lead',
        quote: 'These get opened. The handwriting font and live stamp make all the difference — our response rates beat everything else we send.',
        color: 'bg-[#ED5C2F]',
    },
    {
        initials: 'AL',
        name: 'Alicia L.',
        role: 'Operations Manager',
        quote: 'The team actually helped us build the right list, not just print letters. Clean ordering and the targeting help was the difference.',
        color: 'bg-[#F28230]',
    },
    {
        initials: 'RT',
        name: 'Ray T.',
        role: 'Owner',
        quote: "Fast turnaround, easy to reorder, and the letters look genuinely personal. It's become a core part of our outreach.",
        color: 'bg-[#3F454F]',
    },
]

const reviewAvatarTones = ['bg-[#ED5C2F]', 'bg-[#F28230]', 'bg-[#3F454F]']

const getReviewInitials = (name = '') =>
    String(name)
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() || '')
        .join('')

const getHomepageReviewRating = (review) => {
    const value = Number(review?.ratings)
    if (!Number.isFinite(value) || value <= 0) return 5
    return Math.min(5, Math.max(1, Math.round(value)))
}

const normalizeLabelText = (value) =>
    String(value || '')
        .toLowerCase()
        .replace(/<[^>]*>/g, ' ')
        .replace(/\([^)]*\)/g, ' ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()

const getNormalizedPostageValue = (value, attributes) => {
    if (!value) return value

    const postageField = getPostageField(attributes)
    const options = Array.isArray(postageField?.options)
        ? postageField.options
        : []

    if (options.includes(value)) return value

    const normalizedValue = normalizeLabelText(value)

    const exactNormalizedMatch = options.find(
        (option) => normalizeLabelText(option) === normalizedValue,
    )
    if (exactNormalizedMatch) return exactNormalizedMatch

    const isFirstClass = normalizedValue.includes('first class')
    const isStandardClass = normalizedValue.includes('standard class')

    if (isFirstClass) {
        const firstClassOption = options.find((option) =>
            normalizeLabelText(option).includes('first class'),
        )
        if (firstClassOption) return firstClassOption
    }

    if (isStandardClass) {
        const standardOption = options.find((option) =>
            normalizeLabelText(option).includes('standard class'),
        )
        if (standardOption) return standardOption
    }

    return value
}

const extractUrlsFromMetaValue = (value) => {
    const stringValue = String(value || '')
    const hrefMatches = [
        ...stringValue.matchAll(/href\s*=\s*['"]([^'"]+)['"]/gi),
    ].map((match) => match[1])

    if (hrefMatches.length > 0) return hrefMatches

    return stringValue
        .split('\n')
        .map((entry) => entry.trim())
        .filter(Boolean)
        .map((entry) => {
            const directUrlMatch = entry.match(/(https?:\/\/[^\s"'<>]+)/i)
            return directUrlMatch?.[1] || null
        })
        .filter(Boolean)
}

function ProductPage({
    product,
    addOnProducts,
    multiTouchProducts,
    productCategories,
    productImages: originalProductImages,
    fields,
    variations,
    slug,
    variationsAttrs,
    templateIndustries,
    reviews,
}) {
    const { attributes: originalAttributes, default_attributes: defaults } =
        product
    const [variationId, setVariationId] = useState()
    const [variation, setVariation] = useState()
    const { templates_and_attributes } = fields
    const [productImages, setProductImages] = useState(originalProductImages)

    const [userPricing, setUserPricing] = useState([])

    const [minQuantity, setMinQuantity] = useState(200)
    const [quantity, setQuantity] = useState(200)
    const [loading, setLoading] = useState(false)
    const [enableCustomization, setEnableCustomization] = useState(false)

    const [price, setPrice] = useState(1)
    const [removedRows, setRemovedRows] = useState(0)
    const [attributes, setAttributes] = useState([])

    const ImageGalleryRef = useRef()
    const router = useRouter()

    const Csvfiles = CsvStore((state) => state.files)
    const User = UserStore((state) => state.user)
    const [productCsvs, setProductCsvs] = useState([])
    const resetFiles = CsvStore((state) => state.reset)
    const removeCSV = CsvStore((state) => state.remove)

    // const addNotice = NoticeStore((state) => state.add)

    // log('multiTouchProducts', multiTouchProducts)

    const [shouldReset, setShouldReset] = useState(false)
    const [defaultCustomizationTemplate, setDefaultCustomizationTemplate] =
        useState({})

    /*
    This is to set add-on Products
    */
    const saveAddOnProducts = AddOnProducts((state) => state.save)

    const [total, setTotal] = useState(0)
    const [totalInvalids, setTotalInvalids] = useState(0)
    const [totalValids, setTotalValids] = useState(0)

    const [stepsAndFields, setStepsAndFields] = useState([])
    const [streetviewLocked, setStreetviewLocked] = useState(false)

    const isThisMultiTouchProduct = isMultiTouchProduct(product)

    // Determine if template gallery button should be shown
    const hasTemplates =
        templates_and_attributes && templates_and_attributes.length > 0
    const showTemplateGalleryButton = hasTemplates && !isThisMultiTouchProduct

    const [cyoPrice, setCYOPrice] = useState(0)
    const postcardSizeTargetTitle = 'OLM Postcard Sizes with mockups'

    const [totalSteps, setTotalSteps] = useState(1)
    const [currentStep, helpers] = useStep(totalSteps)
    const {
        canGoToPrevStep,
        canGoToNextStep,
        goToNextStep,
        goToPrevStep,
        setStep,
    } = helpers

    const defaultValues = () => {
        const default_ = {
            [customizeMailPieceField.name]: customizeMailPieceField.default,
        }
        if (shouldAddPagesAndPrinting({ slug })) {
            default_[pagesAndPrintingField.name] =
                pagesAndPrintingField.defaultValue
        }
        //console.log('defaultValues for customizeMailPieceField', default_)
        // Keep the default false value even for multi-touch products
        // so PreDefinedInput can work when customization is disabled
        return default_
    }

    const purchaseListProduct = addOnProducts.find(
        (item) => item.option_name == purchaseField.name,
    )
    const addModal = ModalStore((state) => state.add)
    const faqItems =
        Array.isArray(fields?.faq) && fields.faq.length > 0
            ? fields.faq
            : personalLettersFaqs
    const homepageReviews =
        Array.isArray(reviews) && reviews.length > 0
            ? reviews
                  .filter((review) => review.type === 'Text')
                  .sort(
                      (a, b) =>
                          String(a?.text || '').length -
                          String(b?.text || '').length,
                  )
                  .slice(0, 3)
            : []

    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        setError,
        clearErrors,
        watch,
        reset,
        getValues,
    } = useForm({
        resolver: async function () {
            const values = arguments[0]
            return await yupResolver(
                singleProductRules({
                    values,
                    currentStep,
                    stepsAndFields,
                    product,
                    multiTouchProducts,
                    slug,
                    isThisMultiTouchProduct,
                    totalSteps,
                }),
            )(...arguments)
        },

        /**
         * @TODO
         * include Locals from constants such as leadFiles
         */
        defaultValues: defaultValues(),
    })

    const SummaryComponent = isCYOProduct(product) ? CYOCartInfo : CartInfo

    const getStepErrors = () => {
        const currentStepData = stepsAndFields[currentStep - 1]
        const currentStepName = currentStepData?.name
        const stepFields = Array.isArray(currentStepData?.fields)
            ? currentStepData.fields
            : []
        const stepFieldNames = stepFields
            .map((field) => field?.name)
            .filter(Boolean)

        if (currentStepName === 'Your mailing list') {
            if (
                getValues(mappingListGroupField.name) ===
                customerHasNoListOptionValue
            ) {
                stepFieldNames.push(noOfRecordsField.name, purchaseField.name)
            } else if (
                getValues(mappingListGroupField.name) ===
                customerHasListOptionValue
            ) {
                stepFieldNames.push(leadField.name, rosField.name)
            }
        }

        if (errors?.[pagesAndPrintingField.name]) {
            stepFieldNames.push(pagesAndPrintingField.name)
        }

        if (
            isRealPennedProfessionalLetterProduct(product) ||
            isRealPennedLetterProduct(product)
        ) {
            stepFieldNames.push('variation', 'quantity')
        }

        return pick(errors, stepFieldNames)
    }

    const stepErrors = getStepErrors()

    const getDuplicateMetaKey = (key) => {
        const normalizedKey = normalizeLabelText(key)

        if (normalizedKey.includes('streetview image')) {
            return streetviewImageFieldName
        }

        if (normalizedKey.includes(normalizeLabelText(postcardSizeFieldName))) {
            return postcardSizeFieldName
        }

        return key
    }

    const getDuplicatableField = (fieldName) => {
        const stepFields = stepsAndFields.flatMap((step) =>
            Array.isArray(step?.fields)
                ? step.fields.flatMap((item) =>
                      Array.isArray(item?.fields)
                          ? [item, ...item.fields]
                          : [item],
                  )
                : [],
        )
        const attributeFields = Array.isArray(attributes) ? attributes : []
        const fieldSources = [...stepFields, ...attributeFields]

        const isDuplicatableFieldMatch = (item) => {
            const itemName = item?.name || ''
            if (
                itemName.startsWith(`From ${previsoulyDesignedFileFieldName}`)
            ) {
                return false
            }
            const normalizedItemName = normalizeLabelText(itemName)
            const normalizedFieldName = normalizeLabelText(fieldName)
            return (
                itemName === fieldName ||
                itemName.includes(fieldName) ||
                normalizedItemName.includes(normalizedFieldName)
            )
        }

        return (
            fieldSources.find((item) => item?.name === fieldName) ||
            fieldSources.find(isDuplicatableFieldMatch)
        )
    }

    const getPrimitiveDuplicateValue = (value) => {
        if (isUndefined(value) || value === null) return ''
        if (typeof value === 'boolean') return value ? 'yes' : 'no'
        if (typeof value === 'number') return String(value)
        if (typeof value === 'string') {
            return value.replace(/<[^>]*>/g, ' ').trim()
        }
        return ''
    }

    const normalizeDuplicateOptionText = (value) =>
        String(value || '')
            .toLowerCase()
            .replace(/<[^>]*>/g, ' ')
            .replace(/[^a-z0-9.]+/g, ' ')
            .trim()

    const normalizeDuplicateDimensionText = (value) =>
        normalizeDuplicateOptionText(value).replace(
            /(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/g,
            '$1x$2',
        )

    const getPostcardSizeAliasMatch = (value, options = []) => {
        const normalizedValue = normalizeDuplicateDimensionText(value)

        const aliasMap = {
            '4x6': ['4x6', '4.25x5.5', 'small'],
            '4.25x5.5': ['4.25x5.5', '4x6', 'small'],
            '6x9': ['6x9', 'medium'],
            '6x11': ['6x11', 'large'],
            '9x12': ['9x12', 'jumbo', 'extra large'],
        }

        const aliases = aliasMap[normalizedValue]
        if (!aliases) return null

        return (
            options.find((option) => {
                const normalizedOption = normalizeDuplicateDimensionText(option)
                return aliases.some((alias) => normalizedOption.includes(alias))
            }) || null
        )
    }

    const normalizeDuplicateOptionValue = (value, options = []) => {
        const stringValue = getPrimitiveDuplicateValue(value)
        if (!stringValue) return null

        if (options.includes(stringValue)) return stringValue

        const normalizedValue = normalizeDuplicateOptionText(stringValue)
        const normalizedDimensions =
            normalizeDuplicateDimensionText(stringValue)
        return (
            options.find(
                (option) =>
                    normalizeDuplicateOptionText(option) === normalizedValue,
            ) ||
            options.find((option) => {
                const normalizedOption = normalizeDuplicateDimensionText(option)
                return (
                    normalizedOption.includes(normalizedDimensions) ||
                    normalizedDimensions.includes(normalizedOption)
                )
            }) ||
            null
        )
    }

    const getNormalizedDuplicatePostcardSizeValue = (value) => {
        const postcardSizeField = getDuplicatableField(postcardSizeFieldName)
        const options = Array.isArray(postcardSizeField?.options)
            ? postcardSizeField.options
            : []
        const primitiveValue = getPrimitiveDuplicateValue(value)

        if (!options.length) return primitiveValue || null

        return (
            normalizeDuplicateOptionValue(value, options) ||
            getPostcardSizeAliasMatch(value, options) ||
            primitiveValue ||
            null
        )
    }

    const setDuplicatePostcardSizeValue = (nextValues, value) => {
        const postcardSizeValue = getNormalizedDuplicatePostcardSizeValue(value)
        const postcardSizeField = getDuplicatableField(postcardSizeFieldName)
        const fieldName = postcardSizeField?.name || postcardSizeFieldName

        if (!postcardSizeValue) return {}

        nextValues[fieldName] = postcardSizeValue
        nextValues[postcardSizeFieldName] = postcardSizeValue

        return {
            [fieldName]: postcardSizeValue,
            [postcardSizeFieldName]: postcardSizeValue,
        }
    }

    const getNormalizedDuplicateStreetviewValue = (value) => {
        const streetviewField = getDuplicatableField(streetviewImageFieldName)
        const options = Array.isArray(streetviewField?.options)
            ? streetviewField.options
            : []
        const normalizedValue = normalizeLabelText(
            getPrimitiveDuplicateValue(value),
        )
        const shouldUseYes =
            normalizedValue === 'true' ||
            normalizedValue === 'yes' ||
            normalizedValue.startsWith('yes ')
        const shouldUseNo =
            normalizedValue === '' ||
            normalizedValue === 'false' ||
            normalizedValue === 'no' ||
            normalizedValue.startsWith('no ')

        if (!options.length) {
            if (shouldUseYes) return streetviewYesOptionValue
            if (shouldUseNo) return 'No'
            return getPrimitiveDuplicateValue(value) || null
        }

        const noOption = options.find(
            (option) => normalizeLabelText(option) === 'no',
        )
        const yesOption =
            options.find((option) => option === streetviewYesOptionValue) ||
            options.find((option) =>
                normalizeLabelText(option).startsWith('yes'),
            )

        if (shouldUseYes) {
            return yesOption || null
        }

        if (shouldUseNo) {
            return noOption || null
        }

        return normalizeDuplicateOptionValue(value, options)
    }

    const setDuplicateStreetviewValue = (nextValues, value) => {
        const streetviewValue = getNormalizedDuplicateStreetviewValue(value)
        const streetviewField = getDuplicatableField(streetviewImageFieldName)
        const fieldName = streetviewField?.name || streetviewImageFieldName

        if (!streetviewValue) return {}

        nextValues[fieldName] = streetviewValue
        nextValues[streetviewImageFieldName] = streetviewValue

        return {
            [fieldName]: streetviewValue,
            [streetviewImageFieldName]: streetviewValue,
        }
    }

    const lineItemHasStreetviewAddon = (lineItem) => {
        const metaData = Array.isArray(lineItem?.meta_data)
            ? lineItem.meta_data
            : []
        const valuesToMatch = [
            lineItem?.name,
            lineItem?.product_name,
            lineItem?.sku,
            ...metaData.flatMap((meta) => [meta?.key, meta?.value]),
        ]

        return valuesToMatch.some((value) =>
            normalizeLabelText(value).includes('streetview image'),
        )
    }

    const orderHasStreetviewAddon = (order) => {
        const lineItems = Array.isArray(order?.line_items)
            ? order.line_items
            : []

        return lineItems.some((lineItem) => {
            if (lineItem === first(lineItems)) return false
            return lineItemHasStreetviewAddon(lineItem)
        })
    }

    async function duplicatePreviousOrderSelections(orderLabel) {
        const orderIdMatch = String(orderLabel || '').match(/^#(\d+)/)
        const orderId = orderIdMatch ? parseInt(orderIdMatch[1], 10) : 0

        if (!orderId) return

        const { data: order } = await OrderAPI.get(orderId)
        const primaryLineItem = first(order?.line_items || [])
        const metaData = Array.isArray(primaryLineItem?.meta_data)
            ? primaryLineItem.meta_data
            : []

        const metaMap = Object.fromEntries(
            metaData.map((meta) => [meta?.key, meta?.value]),
        )

        const previousSelectTemplateValue =
            metaMap[selectTemplateField.name] || null
        const previousTemplateValue = metaMap[templateField.name] || null
        const nextValues = {
            ...getValues(),
        }
        let duplicateValuesToSet = {}

        if (
            previousTemplateValue &&
            previousSelectTemplateValue === chooseFromGalleryOptionName
        ) {
            const matchedTemplate = templates_and_attributes?.find(
                ({ template }) =>
                    String(template?.name || '')
                        .trim()
                        .toLowerCase() ===
                    String(previousTemplateValue).trim().toLowerCase(),
            )

            if (matchedTemplate?.template) {
                nextValues[templateField.name] = matchedTemplate.template
            }
        }

        const excludedKeys = new Set([
            'Mapping List Group',
            leadField.name,
            MappedFieldName,
            noOfRecordsField.name,
            orderNoForDesignFieldName,
            duplicatePreviousOrderFieldName,
            'Duplicate everything from this order',
            'Comments',
            'Actual Quantity',
            'Total Mailers',
            'Mailers Quantity',
            'Quantity',
            'ReUpload-Time',
            'ReUpload-By',
            'Admin-Upload-Time',
            'Admin-Uploaded-By',
            'files',
            'price',
            'quantity',
            defaultCustomizationTemplateFieldName,
            AttributesFieldName,
            'Mailing Date',
            'Time Between Each Touch',
            'Batch Mailing',
        ])

        metaData.forEach((meta) => {
            const key = meta?.key
            const value = meta?.value
            const duplicateKey = getDuplicateMetaKey(key)

            if (!key || excludedKeys.has(key)) return

            if (duplicateKey === postcardSizeFieldName) {
                duplicateValuesToSet = {
                    ...duplicateValuesToSet,
                    ...setDuplicatePostcardSizeValue(nextValues, value),
                }
                return
            }

            if (duplicateKey === streetviewImageFieldName) {
                duplicateValuesToSet = {
                    ...duplicateValuesToSet,
                    ...setDuplicateStreetviewValue(nextValues, value),
                }
                return
            }

            if (typeof value !== 'string') return

            if (key === selectTemplateField.name) {
                return
            }

            if (key === templateField.name) {
                const templateMatch =
                    String(value).match(
                        /href=['"]([^'"]+)['"][^>]*>([^<]+)</i,
                    ) || null

                if (templateMatch) {
                    nextValues[key] = {
                        url: templateMatch[1],
                        name: templateMatch[2],
                    }
                }
                return
            }

            if (key === customizeMailPieceField.name) {
                nextValues[key] = value === 'true' || value === true
                return
            }

            if (key === postageFieldName) {
                nextValues[postageFieldName] = getNormalizedPostageValue(
                    value,
                    attributes,
                )
                return
            }

            if (key === 'Real Penned Envelope') {
                nextValues['Real Penned Envelope'] = value
                return
            }

            if (key === logoField.name) {
                const fileNames = extractFilenamesFromURL(value)
                const urlMatches = extractUrlsFromMetaValue(value)

                if (urlMatches.length > 0) {
                    nextValues[key] = urlMatches.map((url, index) => ({
                        url,
                        name:
                            fileNames[index] ||
                            url.split('/').pop() ||
                            `Design file ${index + 1}`,
                    }))
                }
                return
            }

            if (
                key === CLIENT_ROS_FILE ||
                key === 'Admin-ROS-File' ||
                key === 'ReUpload-Client-ROS-File' ||
                key === 'ReUpload-Admin-ROS-File' ||
                key === ADMIN_UPLOAD_FILES ||
                key === REUPLOAD_ORIGINAL_FILES ||
                key === REUPLOAD_DELIVERABLE_FILES ||
                key === LeadFieldName ||
                key === MappedFieldName
            ) {
                return
            }

            if (key === 'Mail For Customer') {
                nextValues[key] = value === 'yes'
                return
            }

            nextValues[key] = value
        })

        if (orderHasStreetviewAddon(order)) {
            duplicateValuesToSet = {
                ...duplicateValuesToSet,
                ...setDuplicateStreetviewValue(nextValues, true),
            }
        }

        if (primaryLineItem?.variation_id) {
            setVariationId(primaryLineItem.variation_id)
            const matchedVariation = variationsArray.find(
                ({ id }) => id === primaryLineItem.variation_id,
            )
            if (matchedVariation) {
                setVariation(matchedVariation)
                setMinQuantity(getMinQuantity(matchedVariation))
            }
        }

        if (metaMap[postageFieldName]) {
            nextValues[postageFieldName] = getNormalizedPostageValue(
                metaMap[postageFieldName],
                attributes,
            )
        }

        reset(nextValues)

        Object.entries(duplicateValuesToSet).forEach(([fieldName, value]) => {
            setValue(fieldName, value, {
                shouldDirty: true,
                shouldValidate: true,
            })
        })
    }

    const handleTotal = (totalRows) => {
        const price = handlePricing(variation)
        // console.log('handleTotal', price, totalRows)
        setQuantity(totalRows)
        const totalQuantity = totalRows * getMultiPlier() // this make sense in campaigns
        setTotal(parseFloat(price) * totalQuantity)
    }

    const handleAfterCSVFiles = () => {
        const files = getProductFiles(slug)
        setProductCsvs(files)
        let validLength = 0
        let invalidsLength = 0
        let originalLength = 0
        if (variation) {
            if (files.length > 0) {
                for (const file of files) {
                    validLength += parseInt(file.data.valids.length) - 1 // -1 because of secondary header
                    invalidsLength += parseInt(file.data.invalids.length)
                    originalLength += parseInt(file.originalTotalRows)
                }
            }
        }
        if (validLength > 0) {
            handleTotal(validLength < minQuantity ? minQuantity : validLength)
            setTotalInvalids(invalidsLength)
            setTotalValids(validLength)
            setRemovedRows(originalLength - validLength)
        } else {
            handleTotal(0)
            setTotalValids(0)
        }
        log(validLength, invalidsLength, originalLength)
        log('trigger this when csv files changes after ')
    }

    const variationsArray = variations.map((item) => {
        let { id, attributes } = item
        let optionValues = {}
        attributes.forEach((item) => {
            const { name, option } = item
            optionValues[name] = option
        })
        return {
            id,
            optionValues,
            item,
        }
    })

    const getMultiPlier = () => currentTouchesValue(getValues)

    const handlePricing = (argsVariation = null) => {
        const variationToUse = argsVariation ||
            variation || { id: product.id, item: product }
        let price = getLatestPrice(variationToUse)
        if (isCYOProduct(product)) {
            const valueToProcess = getValues()
            price = calculateCYOPricingBasedOnProducts(
                valueToProcess,
                multiTouchProducts,
                quantity,
            )
            // console.log('price', price, total)
            setCYOPrice(price)
        }
        setPrice(price)
        return price
    }

    const chooseVariation = async (values) => {
        // console.log('coming in chooseVariation')

        //let valueToProcess = { ...values }

        if (isSimpleProduct(product) || isCYOProduct(product)) {
            const variation = {
                id: product.id,
                item: product,
            }
            setVariation(variation)
            setVariationId(variation.id)
            handlePricing(variation)
            return
        }

        const isOrderFromDesignSelected =
            values?.[orderNoForDesignFieldName] &&
            values?.[selectTemplateField.name] ==
                selectPreviouslyDesignedFileFieldName

        if (isOrderFromDesignSelected) {
            await mayBeSelectVariationFromPreviousOrder(values)
            // fall through — pricing driven by current product variation below
        }

        // Price is always determined by the current product's variation matching.
        // When isOrderFromDesignSelected, getValues() reflects any attributes
        // pre-filled by mayBeSelectVariationFromPreviousOrder above.
        const updatedValues = getValues()

        const variation = variationsArray.find(({ optionValues }) => {
            return isMatch(updatedValues, optionValues)
        })

        setVariationId(false)

        if (variation) {
            setVariation(variation)
            setVariationId(variation.id)
            setMinQuantity(getMinQuantity(variation))
            handlePricing(variation)
        } else if (isOrderFromDesignSelected) {
            // no variation matched — fall back to base product price
            handlePricing({ id: product.id, item: product })
        }
    }

    const fetchStepSteps = () => {
        setStepsAndFields(
            getStepsAndFields({
                attributes,
                fields,
                quantity,
                totalSteps,
                product,
                getValues,
                multiTouchProducts,
                showCutomizations: getValues()?.[customizeMailPieceField.name],
                streetviewLocked,
            }),
        )
    }

    const nextStep = () => {
        const currentStepData = stepsAndFields[currentStep - 1]
        const currentStepName = currentStepData?.name

        if (currentStepName !== 'Your mailing list') {
            clearErrors([noOfRecordsField.name, leadField.name, rosField.name])
        }

        handleSubmit((data) => {
            log(data)

            // Get the current step name
            const currentStepData = stepsAndFields[currentStep - 1]
            const currentStepName = currentStepData?.name

            // Only validate minimum quantity on "Your mailing list" step
            // This prevents validation from triggering on other steps (e.g., when using Back button)
            if (
                currentStepName === 'Your mailing list' &&
                data[mappingListGroupField.name] ===
                    customerHasNoListOptionValue &&
                has(data, noOfRecordsField.name)
            ) {
                const minQty = variation
                    ? getMinQuantity(variation)
                    : minQuantity
                const enteredQty = Number(data[noOfRecordsField.name])

                if (enteredQty < minQty) {
                    setError(noOfRecordsField.name, {
                        type: 'custom',
                        message: `Quantity cannot be less than minimum quantity (${minQty}). Please enter a valid number.`,
                    })
                    return // Stop progression
                }
            }

            chooseVariation(data)
            slideImageToFileUpload()
            if (isCYOProduct(product)) {
                log2('totalSteps', totalSteps, currentStep)
                if (totalSteps - currentStep == 2) {
                    log2('has come here')
                    fetchStepSteps()
                }
            }
            goToNextStep()
        })()
    }

    const handleSetTemplateOptions = (fieldName, fieldValue) => {
        // if (!url) url = getValues(selectTemplateField.name)
        //console.log('handleSetTemplateOptions', fieldName, fieldValue)
        // if (!url) return

        if (isMultiTouchProduct(product)) return

        if (
            fieldName?.includes(selectTemplateField.name) &&
            fieldValue?.includes(designMyFileFieldName)
        ) {
            if (
                (isRealPennedProfessionalLetterProduct(product) ||
                    isRealPennedLetterProduct(product)) &&
                isEmpty(getValues(handWritingFieldName))
            ) {
                const options =
                    originalAttributes.find(
                        (item) => item.name === handWritingFieldName,
                    )?.options || []
                const defaultStyle =
                    options.find(
                        (option) =>
                            String(option).trim().toLowerCase() === 'print',
                    ) || options[0]
                if (defaultStyle) setValue(handWritingFieldName, defaultStyle)
            }
            setDefaultCustomizationTemplate({})
            setValue(customizeMailPieceField.name, true)
            setEnableCustomization(true)
            return
        }

        const getAppearanceFieldDefaultValue = (key) => {
            const field =
                attributes.find((item) => item?.name === key) ||
                originalAttributes.find((item) => item?.name === key)
            const options = Array.isArray(field?.options) ? field.options : []

            if (key === handWritingFieldName) {
                const printOption = options.find((option) =>
                    String(option).trim().toLowerCase().startsWith('print'),
                )

                if (printOption) return printOption
            }

            return options.length > 0 ? options[0] : null
        }

        const getTemplateAppearanceValue = (key, value) => {
            const normalizedValue = String(value || '')
                .trim()
                .toLowerCase()
            const shouldUseDefault =
                isEmpty(value) || normalizedValue === 'not applicable'

            if (!shouldUseDefault) return value

            return getAppearanceFieldDefaultValue(key)
        }

        if (templateField.name == fieldName && fieldValue) {
            const template = templates_and_attributes.find(
                ({ template }) => template.url == fieldValue.url,
            )

            if (template) {
                const templateAttributes = template.attributes || {}
                setDefaultCustomizationTemplate(templateAttributes)

                appearanceFieldNames.forEach((key) => {
                    // Template metadata can contain fields from another
                    // product family (for example Envelope Style on a
                    // postcard template). Only apply values this product
                    // actually exposes.
                    const productSupportsField = [
                        ...originalAttributes,
                        ...attributes,
                    ].some((attribute) => attribute?.name === key)
                    if (!productSupportsField) return

                    const appearanceValue = getTemplateAppearanceValue(
                        key,
                        templateAttributes[key],
                    )

                    if (isEmpty(appearanceValue)) return

                    setValue(key, appearanceValue)
                })
            }
        }
    }

    const slideImageToFileUpload = () => {}

    const prepareDataForAddToCart = async (data) => {
        let returnData = {}
        for (const key of Object.keys(data)) {
            const value = data[key]

            if (Array.isArray(value)) {
                const firstItem = value[0]
                const isRemoteFileReference =
                    firstItem &&
                    typeof firstItem === 'object' &&
                    typeof firstItem.url === 'string' &&
                    !firstItem.data

                returnData[key] = isRemoteFileReference
                    ? value
                    : await convertFilesTobase64(value)
            } else {
                returnData[key] = value
            }
        }
        return returnData
    }

    const removeRedundantFields = (data) => {
        if (!data) return

        const fieldMap = {
            [mappingListGroupField.name]: {
                value: 'no',
                deleteFields: [leadField.name, MappedFieldName.name],
            },
            [selectTemplateField.name]: {
                value: selectPreviouslyDesignedFileFieldName,
                deleteFields: [orderNoForDesignFieldName],
                notEqual: true,
            },
        }

        let isDefaultRequired = true

        // Iterate through the fieldMap
        for (const field in fieldMap) {
            if (field in data) {
                if (
                    (fieldMap[field].notEqual &&
                        data[field] !== fieldMap[field].value) ||
                    (!fieldMap[field].notEqual &&
                        data[field] === fieldMap[field].value)
                ) {
                    fieldMap[field].deleteFields.forEach((delField) => {
                        delete data[delField]
                    })
                }
                isDefaultRequired = false
            }
        }

        // If no conditions were met, delete default field
        if (isDefaultRequired) {
            delete data[noOfRecordsField.name]
        }

        delete data[mailerKeyName]

        return data
    }

    const updatedErrorMessages = (e) => {
        const message = String(getErrorMessage(e))
        if (
            message
                .toLowerCase()
                .includes('cannot create order from empty cart')
        ) {
            return message + ' Please logout and login again.'
        }
        return message
    }

    const handleAddToCart = (e) => {
        e.preventDefault()

        /**
         * @TODO
         * it would better if we can just validate leadFile when its blank
         */
        const hasLeadFileInputInSteps = hasLeadFileInput(stepsAndFields)

        handleSubmit(async (data) => {
            try {
                setLoading(true)

                if (Number(quantity) < 1 && hasLeadFileInputInSteps) {
                    setError('quantity', {
                        type: 'custom',
                        message:
                            'Quanity cannot be 0. Please upload at least one csv file.',
                    })
                    return
                }

                if (!variation) {
                    setError('variation', {
                        type: 'custom',
                        message: 'Please select a variation.',
                    })
                    return
                }

                const link = '/product/' + slug

                let cleanData = omit(data, ['toc', 'null', 'attributes']) // @todo have to why this null is coming

                // Do not send appearance metadata that belongs to a different
                // product family, even if a stale field value survives in the
                // form controller or arrives through template metadata.
                const supportedAppearanceFields = new Set(
                    [...originalAttributes, ...attributes]
                        .map((attribute) => attribute?.name)
                        .filter(Boolean),
                )
                appearanceFieldNames.forEach((fieldName) => {
                    if (!supportedAppearanceFields.has(fieldName)) {
                        delete cleanData[fieldName]
                    }
                })

                cleanData = preprareWithLogoArrayString(
                    cleanData,
                    isMultiTouchProduct({ slug }),
                )

                // const _product = variation?.item || variation

                // const priceToAdd = cyoPrice
                //     ? cyoPrice
                //     : _product
                //     ? getPrice(_product, quantity, getMultiPlier())
                //     : price

                const priceToAdd = handlePricing()

                cleanData.price = priceToAdd
                const quanityBeforeMultiplier = quantity
                cleanData.quantity = quantity * getMultiPlier()

                cleanData = mayBeConvertTemplateURLToATag(cleanData)

                cleanData = await prepareDataForAddToCart(cleanData)

                /**
                 * we handle this by using muitplied data entry in backend.
                 */
                if (isCampaignProduct({ slug })) {
                    // This actual Mailers
                    cleanData[MAILERS_QUANTITY_METAKEY] = Number(quantity)
                    // quanity would be multiplied by touches
                    cleanData[TOTLAMAILERS_METAKEY] = Number(
                        getMultiPlier() * quantity,
                    )
                }

                // we don't need this anymore as we now showing direct pricing.
                // we need to remove change_price from 'woocommerce_before_calculate_totals' hook from WooCart Plugin
                cleanData[ACTUAL_QUANTITY_METAKEY] = String(totalValids) // this is used in control sheet
                cleanData[_CAMPAIGN_PRICE_KEY] = cleanData.price // set campaign price

                /** @TODO this should be handled via hidden field which is already getting add
                 * throught getStepsAndFields
                 */

                if (isCYOProduct(product)) {
                    const mailerProductNames =
                        filterMaileTypesFromGetValues(data)
                    log2('mailerProductNames', mailerProductNames)
                    Object.entries(mailerProductNames).forEach(
                        ([mailerKey, mailerProductName]) => {
                            const name =
                                String(mailerProductName).toLocaleLowerCase()
                            const mailerPostageKey = `${mailerKey} ${postageFieldName}`
                            const mailerPostageValue =
                                cleanData?.[mailerPostageKey]
                            const isStandardClassMailer =
                                mailerPostageValue === standardClassPostage

                            if (isStandardClassMailer) return

                            if (!shouldAddShippingCampaignProduct(name)) return

                            log2('shouldAddShippingCampaignProduct', name)
                            log2(
                                'getshippingFieldName({ name })',
                                getshippingFieldName({ slug: name }),
                            )
                            // if this already added we need to increase the quantity
                            if (
                                has(
                                    cleanData,
                                    getshippingFieldName({ slug: name }),
                                )
                            ) {
                                cleanData[
                                    getshippingFieldName({ slug: name })
                                ] =
                                    parseInt(
                                        cleanData[
                                            getshippingFieldName({ slug: name })
                                        ],
                                    ) + getNoOfShippingFee(totalValids)
                            } else {
                                cleanData[
                                    getshippingFieldName({ slug: name })
                                ] = getNoOfShippingFee(totalValids)
                            }
                        },
                    )
                }

                // throw new Error('Testing')

                if (shouldAddShipping(slug)) {
                    cleanData[getshippingFieldName({ slug })] =
                        getNoOfShippingFee(totalValids)
                }

                if (hasSetNoOfRecordsManually(cleanData)) {
                    cleanData = handleManuallySetNoOfRecords(
                        cleanData,
                        quanityBeforeMultiplier,
                    )
                }

                const minQuantity = getMinQuantity(variation)

                console.log('quantity', typeof quantity, quantity, minQuantity)

                if (
                    Number(quantity) < Number(minQuantity) &&
                    has(data, noOfRecordsField.name)
                ) {
                    setError('quantity', {
                        type: 'custom',
                        message: `Quanity cannot be less than minimum Quantity. Please enter a valid number in
                            ${noOfRecordsField.label}.`,
                    })
                    return
                }

                cleanData = removeRedundantFields(cleanData)

                handleShouldDeleteMetasAndValueChange(cleanData)

                const cartItem = {
                    productId: product.id,
                    productCategories,
                    ...cleanData,
                    variation,
                    product: {
                        slug,
                        name: product.name,
                        link,
                    },
                    files: getProductFiles(slug),
                }

                //console.log('cleanItem cleanData', cleanData)

                // throw Error('check clean item')

                await processAddToCart(cartItem) // this add on in add on cart
                afterAddToCart(cartItem)
            } catch (e) {
                console.log('add to cart', e)
                const message = getErrorMessage(e)
                log(message)
                if (message.includes(pagesAndPrintingVariationErrorMessage)) {
                    setError(pagesAndPrintingField.name, {
                        type: 'custom',
                        message: pagesAndPrintingVariationErrorMessage,
                    })
                } else {
                    showWentWrongModal(updatedErrorMessages(e))
                }
            } finally {
                setLoading(false)
            }
        })()
    }

    const fullReset = () => {
        resetFiles()
        setShouldReset((state) => !state)
        reset(defaultValues())
        setStep(1)
        setVariation(null)
        setVariationId(null)
        setMinQuantity(0)
        setPrice(1)
        setQuantity(0)
        setRemovedRows(0)
        setTotalInvalids(0)
        setTotalValids(0)
        setTotal(0)
        setProductCsvs([])
        handleMount()
    }

    const afterAddToCart = async () => {
        await ThoughtMetrics.cart({
            total,
        })
        router.push('/cart')
    }

    const handlEscKey = (e) => {
        if (e.keyCode == 27) {
            e.stopImmediatePropagation()
        }
    }

    const removeCsv = (name, product) => {
        removeCSV(name, product) // Lets Remove CSV first
    }

    const stepsFields = getStepsAndFields({
        attributes,
        fields,
        quantity,
        totalSteps,
        product,
        getValues,
        multiTouchProducts,
        showCutomizations: getValues()?.[customizeMailPieceField.name],
        streetviewLocked,
    })

    const getAddOnProductsForStore = useCallback(() => {
        const shouldInvalidatePagesPrintingVariation =
            process.env.NODE_ENV !== 'production' &&
            router.query?.invalidatePagesPrintingVariation === '1'

        if (!shouldInvalidatePagesPrintingVariation) {
            return addOnProducts
        }

        return addOnProducts.map((item) =>
            item.option_name === pagesAndPrintingField.name
                ? {
                      ...item,
                      variations: [],
                  }
                : item,
        )
    }, [addOnProducts, router.query?.invalidatePagesPrintingVariation])

    const handleMount = () => {
        getTotalSteps(product)
        saveAddOnProducts(getAddOnProductsForStore())
        setStepsAndFields(stepsFields)
        setPrice(product.price)
        setMinQuantity(getMinQuantity(product))
        resetFiles()
        if (!isMultiTouchProduct({ slug })) {
            setValue(customizeMailPieceField.name, false)
        }
    }

    const mayChooseVariation = (selectedItem, value) => {
        clearErrors(selectedItem.name)

        if (selectedItem.name === pagesAndPrintingField.name) {
            return
        }

        if (
            shouldFollowNewOrderProcess(product) &&
            (isPostageField(selectedItem) ||
                isPurchaseListField(selectedItem) ||
                isPostcardSizeField(selectedItem) ||
                isRealPennedEnvelopeField(selectedItem))
        )
            return

        /**
         * @Logic
         * So we will find all attrs fo variations which are fullfilling condition of selected item
         * we then get all attrs which are greater position than this one
         * and then we make their options and option for those keys (attrs)
         * and then we will set options in main attrs and those Listbox reset once item.option changes
         */

        if (shouldChangeTotalSteps(product, selectedItem)) {
            setTotalSteps(
                getTotalSteps(product, totalStepsForMultiTouch(value)),
            )
        }

        handleDesignOnFile({
            selectedItem,
            getValues,
            stepsFields,
            setStepsAndFields,
        })

        const filteredRemovedSelectedAttr = variationsAttrs.filter((items) => {
            return items.find(
                ({ name, option }) =>
                    name === selectedItem.name && option === value,
            )
        })

        const OnlyGreaterOnes = filteredRemovedSelectedAttr.map((items) => {
            return items.filter(
                ({ position }) => position > selectedItem.position,
            )
        })

        const attrItems = {}
        for (const { name, option } of flatten(OnlyGreaterOnes)) {
            attrItems[name] && !attrItems[name].includes(option)
                ? attrItems[name].push(option)
                : !attrItems[name]
                ? (attrItems[name] = [option])
                : null
        }

        if (Object.keys(attrItems).length > 0) {
            // Lets set Attributes now
            setAttributes(
                produce((draft) => {
                    for (const key of Object.keys(attrItems)) {
                        const attr = draft.find(({ name }) => name === key)
                        if (attr) {
                            attr.options = attrItems[key]
                        }
                    }
                }),
            )
        }
    }

    // const getLatestPrice = (argsVariation = null) => {
    //     let price = 0
    //     const useVariation = argsVariation ? argsVariation : variation
    //     if (useVariation) {
    //         price = getPrice(useVariation?.item, quantity, getMultiPlier())
    //     }
    //     return price
    // }

    // Convert user pricing tiers to the format expected by getTieredPrice
    const convertUserPricingToRulesFormat = () => {
        if (
            !userPricing ||
            !userPricing.pricing_tiers ||
            userPricing.pricing_tiers.length === 0
        ) {
            return null
        }

        // Convert array of tiers to object format like your existing rules
        const rulesObject = {}
        userPricing.pricing_tiers.forEach((tier) => {
            rulesObject[tier.quantity] = tier.price
        })

        return {
            rules: rulesObject,
            type: userPricing.pricing_type || 'fixed', // from API response
        }
    }

    // New function to get user-specific price using your existing getTieredPrice logic
    const getUserSpecificPrice = (qty) => {
        const userRules = convertUserPricingToRulesFormat()
        if (!userRules) {
            return null
        }

        // Use your existing getTieredPrice function with user's rules
        const basePrice =
            variation?.item?.price || variation?.item?.sale_price || 0
        return getTieredPrice(userRules.rules, qty, userRules.type, basePrice)
    }

    // Updated to incorporate user pricing
    const getLatestPrice = (argsVariation = null) => {
        const User = UserStore.getState().user // Direct access without subscription
        const useVariation = argsVariation ? argsVariation : variation

        let price = getPrice(useVariation?.item, quantity, getMultiPlier())

        if (useVariation) {
            if (User) {
                const userPrice = getUserSpecificPrice(quantity)
                price =
                    userPrice !== null
                        ? userPrice * getMultiPlier()
                        : getPrice(
                              useVariation?.item,
                              quantity,
                              getMultiPlier(),
                          )
            }
        }
        return price
    }

    // // watch field value
    const customizeMailPieceFieldKey = watch(customizeMailPieceField.name)
    const postageFieldValue = watch(postageFieldName)

    useEffect(() => {
        if (isCYOProduct(product)) return
        const isStandardClass = postageFieldValue === standardClassPostage

        if (isStandardClass) {
            setValue(realPennedAdditionalFields.name, true)
        }
    }, [postageFieldValue, setValue, product])

    const getStepName = (stepName) => {
        return stepName
    }

    const getStepAuxTitle = (stepName) => {
        const values = getValues()
        const getStepNumber = extractMailerNumber(stepName)
        if (!getStepNumber) return null

        const mailerTypeName = 'Mailer Type ' + getStepNumber
        return values[mailerTypeName] || null
    }

    const handleSelectSliderImage = (fieldValue) => {
        // log('selectTemplateField', fieldValue)
        const url = fieldValue?.url
        if (url) {
            const newImages = [
                {
                    original: url,
                    thumbnail: url,
                },
                ...originalProductImages,
            ]
            // log('newImages', newImages.length, originalProductImages.length)
            setProductImages(newImages)
        }

        // log('selectTemplateField', fieldValue)
    }

    const slideGalleryToPostcardSizeImage = () => {
        if (!ImageGalleryRef.current) return

        const galleryItems =
            ImageGalleryRef.current?.props?.items || productImages

        if (!Array.isArray(galleryItems) || !galleryItems.length) return

        const targetIndex = galleryItems.findIndex(
            (item) => item?.originalTitle === postcardSizeTargetTitle,
        )

        if (targetIndex < 0 || targetIndex >= galleryItems.length) return

        ImageGalleryRef.current.slideToIndex(targetIndex)
    }

    const handleUserPricing = async () => {
        try {
            const userId = User.ID

            if (!userId) return

            const { data: userPricingObj } = await EcomAPI.getUserPricing(
                product.id,
                userId,
            )
            const userPricing = userPricingObj?.pricing_tiers
            if (userPricing) {
                console.log('userPricing', userPricingObj)
                setUserPricing(userPricingObj)
            }
        } catch (e) {
            console.log('error', e)
        }
    }

    const handleOpenTemplateGallery = () => {
        const addModal = ModalStore.getState().add

        addModal(
            <SelectTemplateModal
                templates_and_attributes={templates_and_attributes}
                templateIndustries={templateIndustries}
                setValue={setValue}
                getValues={getValues}
                afterSelection={(value) => {
                    log('Template selected from gallery button', value)
                    setValue(
                        selectTemplateField.name,
                        chooseFromGalleryOptionName,
                    )
                }}
                item={templateField}
            />,
        )
    }

    const mayBeSelectVariationFromPreviousOrder = useCallback(
        async (data) => {
            // Select/type the order #
            // This function only pre-fills form attributes from the referenced order.
            // Pricing is handled by chooseVariation after this returns.
            const orderNoForDesign = data[orderNoForDesignFieldName]

            const matches = [...orderNoForDesign.matchAll(/\[(\d+)\]/g)]
            const variationID = matches.length
                ? parseInt(matches[matches.length - 1][1], 10)
                : 0

            if (!variationID) {
                // Simple product — fetch parent product to read any attributes,
                // but do not set variation or price (handled by chooseVariation).
                const pidMatch = orderNoForDesign.match(/\[pid:(\d+)\]/)
                const productId = pidMatch ? parseInt(pidMatch[1], 10) : 0

                if (productId) {
                    await EcomAPI.getProductById(productId)
                    // no attribute pre-fill needed for simple products
                }
                return
            }

            const { data: fetchedVariation } = await EcomAPI.getProductById(
                variationID,
            )

            if (fetchedVariation) {
                fetchedVariation?.attributes.map((obj) => {
                    if (obj?.name && obj?.option) {
                        setValue(
                            `From ${previsoulyDesignedFileFieldName} ` +
                                obj.name,
                            obj.option,
                        )
                    }
                    // else {
                    //     console.warn('Attributes missing key properties:', obj)
                    // }
                })
            }
        },
        [setValue],
    )

    useEffect(() => {
        setEnableCustomization(customizeMailPieceFieldKey)
    }, [customizeMailPieceFieldKey])

    useEffect(() => {
        setValue('variationId', variationId)
    }, [variationId, setValue])

    useEffect(() => {
        log('errors', errors)
    }, [errors])

    useEffect(() => {
        // console.log('trigger this when csv files changes')
        handleAfterCSVFiles()
    }, [Csvfiles])

    useEffect(() => {
        const currentStepData = stepsAndFields[currentStep - 1]
        const currentStepName = currentStepData?.name

        if (currentStepName !== 'Your mailing list') {
            const names = [noOfRecordsField.name, leadField.name, rosField.name]
            if (!isCYOProduct(product) || names.some((name) => errors[name])) {
                clearErrors(names)
            }
        }
    }, [clearErrors, currentStep, errors, stepsAndFields, product])

    useEffect(() => {
        setStepsAndFields(stepsFields)
        return () => setStepsAndFields([])
    }, [
        attributes,
        totalSteps,
        currentStep,
        postageFieldValue,
        streetviewLocked,
    ])

    // quantity, this was done for batch options

    useEffect(() => {
        setAttributes(originalAttributes)
        log('originalAttributes', originalAttributes)
        return () => setAttributes([])
    }, [originalAttributes])

    useEffect(() => {
        // This page component is reused by Next.js when navigating between
        // product slugs. Restore the new product's full attribute options
        // before rebuilding the steps so options narrowed on the previous
        // product cannot leak into this one.
        setAttributes(originalAttributes || [])
        fullReset()
        setTotalSteps(getTotalSteps(product))
        setStepsAndFields(stepsFields)
        return () => {
            setStepsAndFields([])
            setProductImages([])
        }
    }, [product])

    useEffect(() => {
        handleMount()
        document.addEventListener('keydown', handlEscKey)
        return document.removeEventListener('keydown', handlEscKey)
    }, [])

    useEffect(() => {
        saveAddOnProducts(getAddOnProductsForStore())
    }, [getAddOnProductsForStore, saveAddOnProducts])

    useEffect(() => {
        setEnableCustomization(isCampaignProduct(product))
        return () => {
            setEnableCustomization(false)
        }
    }, [product])

    useEffect(() => {
        // console.log('fired from useEffect total', total)
        handlePricing(variation)
    }, [total, variation, quantity])

    useEffect(() => {
        if (defaultCustomizationTemplate) {
            setValue(
                defaultCustomizationTemplateFieldName,
                defaultCustomizationTemplate,
            )
        }
        return () => setValue(defaultCustomizationTemplateFieldName, null)
    }, [defaultCustomizationTemplate])

    useEffect(() => {
        setValue(AttributesFieldName, attributes)
        return () => setValue(AttributesFieldName, null)
    }, [attributes])

    useEffect(() => {
        if (!productImages.length) return
        if (!originalProductImages.length) return
        if (productImages.length !== originalProductImages.length) {
            ImageGalleryRef.current.slideToIndex(0)
        }
    }, [productImages])

    useEffect(() => {
        setProductImages(originalProductImages)
        return () => setProductImages([])
    }, [router.asPath])

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            const fieldName = name
            const fieldValue = value[name]

            const slugIsPostcardProduct = String(product?.slug || '')
                .toLowerCase()
                .includes('postcard')

            if (fieldName === templateField.name) {
                handleSelectSliderImage(fieldValue)

                if (slugIsPostcardProduct) {
                    const shouldLock = isStreetviewTemplateName(
                        fieldValue?.name,
                    )
                    if (shouldLock) {
                        setValue(
                            streetviewImageFieldName,
                            streetviewYesOptionValue,
                        )
                    }
                    setStreetviewLocked(shouldLock)
                }
            }

            if (
                (fieldName === duplicatePreviousOrderFieldName &&
                    fieldValue === true) ||
                (fieldName === orderNoForDesignFieldName &&
                    value[duplicatePreviousOrderFieldName] === true)
            ) {
                const previousOrderValue = value[orderNoForDesignFieldName]
                if (previousOrderValue) {
                    duplicatePreviousOrderSelections(previousOrderValue).catch(
                        (error) => {
                            console.error(
                                'Failed to duplicate previous order selections',
                                error,
                            )
                            showWentWrongModal(updatedErrorMessages(error))
                            setValue(duplicatePreviousOrderFieldName, false)
                        },
                    )
                }
            }

            if (fieldName === noOfRecordsField.name) {
                setMinQuantity(500)
                handleTotal(fieldValue)
                setTotalInvalids(0)
                setTotalValids(fieldValue)
                setRemovedRows(0)
                log('noOfRecordsField', fieldValue, noOfRecordsField.name)
            }

            const isPostcardSizeFieldChange =
                fieldName === postcardSizeFieldName ||
                fieldName?.includes(postcardSizeFieldName)

            if (slugIsPostcardProduct && isPostcardSizeFieldChange) {
                slideGalleryToPostcardSizeImage()
            }

            // if (fieldName === purchaseField.name) {
            //     fieldValue == true ? setTotalSteps(2) : setTotalSteps(3)
            // }

            const isMailerTypeField = /^Mailer Type \d+$/.test(fieldName || '')
            const isMailerPostageField = new RegExp(
                `^Mailer Type \\d+ ${postageFieldName}$`,
            ).test(fieldName || '')
            const isTouchesField = fieldName === 'Touches'
            const isGlobalPostageField = fieldName === postageFieldName

            if (
                isCYOProduct(product) &&
                (isMailerTypeField ||
                    isMailerPostageField ||
                    isTouchesField ||
                    isGlobalPostageField)
            ) {
                handlePricing({
                    id: product.id,
                    item: product,
                })
            }

            handleSetTemplateOptions(fieldName, fieldValue)
        })
        return () => {
            // console.log('has come in here unsubscribing')
            subscription.unsubscribe()
            setDefaultCustomizationTemplate({})
            setEnableCustomization(false)
        }
    }, [router.asPath])

    useEffect(() => {
        handleUserPricing()
    }, [User])

    // useEffect(() => {
    //     if (router.query?.template && router.query?.templateName) {
    //         const template = {
    //             url: router.query?.template,
    //             name: router.query?.templateName,
    //         }
    //         handleSelectSliderImage(template)
    //     }
    // }, [router.query])

    useEffect(() => {
        if (router.query?.template && router.query?.templateName) {
            console.log('Populating template fields from query params')

            const template = {
                url: router.query.template,
                name: router.query.templateName,
            }

            // Delay setting the values to ensure they populate correctly
            const timeoutId = setTimeout(() => {
                console.log(
                    'Setting template values after delay:',
                    router.query?.template,
                )

                setValue(selectTemplateField.name, chooseFromGalleryOptionName)
                setValue(templateField.name, template)

                // Uncomment if needed
                handleSelectSliderImage(template)
                handleSetTemplateOptions(templateField.name, template)
            }, 50)

            // Cleanup timeout if the component unmounts
            return () => clearTimeout(timeoutId)
        }
    }, [router.query, setValue, selectTemplateField.name, templateField.name])

    return (
        <div key={product.slug} className="bg-[#FFF8F0]">
            <Header
                key={product.slug}
                metaTitle={product.name}
                meta={product.yoast_head}
                hideTitle={true}
            />
            <ContainerWrapper>
                <div className="px-5 pt-10 md:px-0 mb-[22px]">
                    <div className="flex flex-wrap items-center gap-[14px]">
                        <h1 className="text-[32px] font-extrabold leading-none text-olm-black">
                            {product.name}
                        </h1>
                        {showTemplateGalleryButton && (
                            <button
                                type="button"
                                onClick={handleOpenTemplateGallery}
                                className="inline-flex items-center justify-center rounded-full border-[1.5px] border-[#F6D9C2] bg-white px-4 py-[9px] text-[13.5px] font-semibold text-[#ED5C2F] transition-[background-color,transform] duration-150 hover:bg-[#FDF4EC] active:translate-y-[1px] focus:outline-none focus:ring-4 focus:ring-[#F28230]/15">
                                <span className="mr-1 text-[12px] leading-none">
                                    ▦
                                </span>
                                <span>View templates</span>
                            </button>
                        )}
                    </div>
                    <div className="w-auto">
                        <div className="mt-2 text-[13px] font-medium text-gray-400">
                            Shop / {product.name}
                        </div>
                    </div>
                </div>
            </ContainerWrapper>
            {/* <BreadCrumbs list={pages} /> */}
            {loading && <Loader text="Adding to cart..." />}
            <Container>
                <form autoComplete="off" onSubmit={handleAddToCart}>
                    <div className="mt-[-40px] flex w-full flex-col gap-4 md:flex-row md:items-start md:gap-7">
                        <div className="w-full min-w-0 md:flex-1">
                            <DevTool product={product} />
                            <div>
                                {productImages.length > 0 && (
                                    <ImageGallery
                                        ref={ImageGalleryRef}
                                        showPlayButton={false}
                                        items={productImages}
                                        additionalClass="olm-product-gallery"
                                    />
                                )}
                            </div>
                            <section>
                                {product.short_description && (
                                    <div className="relative z-0 mt-[18px] clear-both rounded-2xl border border-[#ECE6DC] bg-white px-[22px] py-5 shadow-[0_1px_2px_rgba(26,29,35,0.04),0_8px_24px_rgba(26,29,35,0.06)]">
                                        <div className="mb-4 flex items-center gap-[10px] text-[16px] font-extrabold text-[#1A1D23]">
                                            <div className="flex h-[30px] w-[30px] items-center justify-center rounded-[8px] bg-[#FDF4EC] text-[#ED5C2F]">
                                                ▤
                                            </div>
                                            <h2>Product Details</h2>
                                        </div>
                                        <div className="product-description text-[13.5px] leading-[1.55] text-[#1A1D23]">
                                            <ParseWordPressHTML>
                                                {product.short_description}
                                            </ParseWordPressHTML>
                                        </div>
                                    </div>
                                )}
                            </section>
                        </div>

                        <div
                            className={
                                'w-full md:sticky md:block md:w-[468px] md:shrink-0'
                            }>
                            <div className="w-full rounded-xl border border-[#ECE6DC] bg-[#FBF8F3] p-4 lg:py-6 lg:pr-6">
                                <Stepper
                                    key={product.slug}
                                    config={{
                                        currentStep,
                                        totalSteps,
                                        goToPrevStep,
                                        nextStep,
                                        canGoToPrevStep,
                                        canGoToNextStep,
                                        errors: stepErrors,
                                        quantity,
                                        finalButton: (
                                            <AddToCartButton className="my-2" />
                                        ),
                                    }}>
                                    {stepsAndFields.map((step, idx) => (
                                        <Step
                                            key={step.name}
                                            title={getStepName(step.name)}
                                            auxTitle={getStepAuxTitle(
                                                step.name,
                                            )}
                                            index={idx + 1}>
                                            {step.name ===
                                            'Your mailing list' ? (
                                                <div className="pb-2">
                                                    <p className="pb-2 text-[13.5px] font-medium leading-[1.65] text-[#6B7280]">
                                                        {step.description}
                                                    </p>
                                                </div>
                                            ) : (
                                                <HeadingText>
                                                    {step.description}
                                                </HeadingText>
                                            )}
                                            {step.name ===
                                                'Your mailing list' && (
                                                <div className="pb-3">
                                                    <a
                                                        href={
                                                            mailingListTemplateUrl
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="inline-flex items-center gap-[6px] text-[13.5px] font-semibold tracking-[-0.01em] text-[#ED5C2F] transition-colors hover:text-[#F28230]">
                                                        <span>
                                                            Download our free
                                                            Mailing List
                                                            Template
                                                        </span>
                                                        <span>→</span>
                                                    </a>
                                                </div>
                                            )}
                                            {step.fields.map((item, ix) => {
                                                // log2('item.name', item.name)
                                                return (
                                                    <ShowField
                                                        key={item.name + ix}
                                                        {...{
                                                            watch,
                                                            templateIndustries,
                                                            templates_and_attributes,
                                                            purchaseListProduct,
                                                            enableCustomization,
                                                            isThisMultiTouchProduct,
                                                            attributes,
                                                            product,
                                                            register,
                                                            getValues,
                                                            shouldReset,
                                                            setValue,
                                                            errors,
                                                            item,
                                                            removeCsv,
                                                            removedRows,
                                                            totalInvalids,
                                                            totalValids,
                                                            minQuantity,
                                                            price,
                                                            quantity,
                                                            getMultiPlier,
                                                            defaultCustomizationTemplate,
                                                            maxLength:
                                                                getMaxLength(
                                                                    slug,
                                                                ),
                                                            defaults,
                                                            multiTouchProducts,
                                                            onSelect:
                                                                mayChooseVariation,
                                                        }}
                                                    />
                                                )
                                            })}
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>
                            {!isUndefined(quantity) && quantity > 0 && (
                                <SummaryComponent
                                    {...(isCYOProduct(product)
                                        ? { control }
                                        : {})}
                                    {...{
                                        productCsvs,
                                        getValues,
                                        watch,
                                        total,
                                        quantity,
                                        register,
                                        variation,
                                        isCampaignProduct: isCampaignProduct({
                                            slug,
                                        }),
                                        getMultiPlier,
                                        price: price,
                                        cyoPrice,
                                        handlePricing,
                                        addOnProducts:
                                            getAddOnProductsForStore(),
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </form>

                {product.description && (
                    <div className="personal-letters-lower mx-auto max-w-[1200px] px-5 md:px-0">
                        <ParseWordPressHTML>
                            {product.description}
                        </ParseWordPressHTML>
                    </div>
                )}

                <>
                    <div className="personal-letters-lower mx-auto max-w-[1200px] px-5 md:px-0">
                        <section className="panel py-10">
                            <div className="panel-lbl">Questions</div>
                            <h2>Before you order</h2>
                            <div className="faq-list">
                                {faqItems.map((faq, index) => (
                                    <details
                                        key={faq.question || `faq-${index}`}
                                        className="faq group">
                                        <summary className="faq-q list-none">
                                            <span>{faq.question}</span>
                                            <span className="faq-chev">
                                                <svg
                                                    width="18"
                                                    height="18"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                    strokeWidth="2">
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M19 9l-7 7-7-7"
                                                    />
                                                </svg>
                                            </span>
                                        </summary>
                                        <div className="faq-a">
                                            <div className="faq-answer">
                                                {typeof faq.answer ===
                                                'string' ? (
                                                    <ParseWordPressHTML>
                                                        {faq.answer}
                                                    </ParseWordPressHTML>
                                                ) : (
                                                    faq.answer
                                                )}
                                            </div>
                                        </div>
                                    </details>
                                ))}
                            </div>
                        </section>

                        <section className="py-10">
                            <div className="rev-head">
                                <div>
                                    <div className="panel-lbl">Reviews</div>
                                    <h2>What customers say</h2>
                                </div>
                            </div>
                            {homepageReviews.length > 0 ? (
                                <div className="rev-grid">
                                    {homepageReviews.map((review, index) => (
                                        <div
                                            key={
                                                review.id ||
                                                review.client?.name ||
                                                review.author ||
                                                `review-${index}`
                                            }
                                            className="rev-card">
                                            <div className="stars">
                                                {'★'.repeat(
                                                    getHomepageReviewRating(
                                                        review,
                                                    ),
                                                )}
                                            </div>
                                            <p className="rev-q">
                                                &quot;{review.text || ''}&quot;
                                            </p>
                                            <div className="rev-author">
                                                <div
                                                    className={`rev-av ${
                                                        reviewAvatarTones[
                                                            index %
                                                                reviewAvatarTones.length
                                                        ]
                                                    }`}>
                                                    {getReviewInitials(
                                                        review.client?.name ||
                                                            review.author ||
                                                            '',
                                                    )}
                                                </div>
                                                <div>
                                                    <div className="rev-name">
                                                        {review.client?.name ||
                                                            review.author ||
                                                            ''}
                                                    </div>
                                                    <div className="rev-role">
                                                        {review.client?.role ||
                                                            review.client
                                                                ?.title ||
                                                            ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="rev-grid">
                                    {personalLettersReviews.map((review) => (
                                        <div
                                            key={review.name}
                                            className="rev-card">
                                            <div className="stars">★★★★★</div>
                                            <p className="rev-q">
                                                &quot;{review.quote}&quot;
                                            </p>
                                            <div className="rev-author">
                                                <div
                                                    className={`rev-av ${review.color}`}>
                                                    {review.initials}
                                                </div>
                                                <div>
                                                    <div className="rev-name">
                                                        {review.name}
                                                    </div>
                                                    <div className="rev-role">
                                                        {review.role}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </section>
                    </div>

                    <div className="personal-letters-final-cta final-cta">
                        <div className="final-cta-inner">
                            <h2>
                                Need help{' '}
                                <span className="accent">
                                    picking a mailer?
                                </span>
                            </h2>
                            <p>
                                Book a quick call and we&apos;ll help you pick
                                the right template, list, and strategy that
                                meets your goal and budget.
                            </p>
                            <button
                                type="button"
                                onClick={() =>
                                    addModal(<HomepageBookCallLeadModal />)
                                }
                                className="cta-btn">
                                <span>Book a call</span>
                                <svg
                                    width="14"
                                    height="14"
                                    fill="none"
                                    viewBox="0 0 16 16"
                                    aria-hidden="true">
                                    <path
                                        d="M3 8h10M9 4l4 4-4 4"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </>
            </Container>
        </div>
    )
}

// Next.js reuses the dynamic route component when only [slug] changes. A
// keyed inner component gives each product a fresh form controller and fresh
// field-local state during client-side navigation.
export default function Product(props) {
    return <ProductPage key={props.slug} {...props} />
}

const shouldLoadFromLocal = false // process.env.NODE_ENV === 'development'

const getIndustriesFromTemplates = (templates = []) => {
    if (!Array.isArray(templates)) return []

    return [
        ...new Set(
            templates.map((item) => item?.template?.industry).filter(Boolean),
        ),
    ]
}

const getData = async (ctx) => {
    const slug = ctx.params.slug
    const isNew = ctx?.query?.new // Check if the ?new flag is set

    const localDataPath = path.join(process.cwd(), 'localData', `${slug}.json`)

    // Check for local environment and if data refresh is not requested
    if (shouldLoadFromLocal && !isNew && fs.existsSync(localDataPath)) {
        // console.log('came in to read file returned from here')
        return JSON.parse(fs.readFileSync(localDataPath, 'utf-8'))
    }

    const ProductAPI = (await import('../../apis/server/ProductAPI')).ProductAPI
    const GeneralAPI = (await import('../../apis/GeneralAPI')).GeneralAPI

    const { data } = await ProductAPI.getProductsBySlug(slug)

    // console.log('product data', data, slug)

    const product = first(data)

    // console.log('product getData', product)

    if (!product) {
        return {
            notFound: true,
        }
    }

    let fields = await GeneralAPI.getACF(slug)
    const defaultAttributes = await GeneralAPI.getDefaultAttributes(slug)

    if (
        has(fields, 'templates_and_attributes') &&
        isArray(fields.templates_and_attributes)
    ) {
        fields.templates_and_attributes.map((field, index) => {
            field.attributes = defaultAttributes[index]
            return field
        })
    }

    let productImages = await getProductImages(product)

    // remove images which were not found
    productImages = productImages.filter((item) => item !== null)

    // variations
    const variations = await ProductAPI.getVariationsByProduct(product)

    let productCategories = []
    productCategories = product.categories.map((category) => category.id)

    /**
     * Now we need to have all Additional Products here too
     * Which will be a simple Array and when Add to Cart Product will be added
     */

    const addOnProducts = await ProductAPI.getACFAddonProducts()

    const multiTouchProducts = await ProductAPI.getACFMultiTouchProducts()

    const variationsAttrs = variations.map(({ attributes }) => {
        return attributes.map((attribute) => {
            const attr = product.attributes.find(
                ({ id }) => id === attribute.id,
            )
            return { ...attribute, position: attr.position }
        })
    })

    let templateIndustries = getIndustriesFromTemplates(
        fields?.templates_and_attributes,
    )

    try {
        const { data: industries } = await GeneralAPI.getACFOptions(
            'options/industries',
        )

        const fetchedIndustries =
            industries?.industries?.map((ind) => ind?.name).filter(Boolean) ||
            []

        if (fetchedIndustries.length > 0) {
            templateIndustries = fetchedIndustries
        }
    } catch (error) {
        console.warn(
            `Product page industries fallback used for slug "${slug}" because ACF options industries could not be loaded.`,
            error?.message || error,
        )
    }

    const dataToSend = {
        product,
        variationsAttrs,
        addOnProducts,
        multiTouchProducts,
        productCategories,
        productImages,
        variations,
        fields,
        slug,
        templateIndustries,
    }

    if (shouldLoadFromLocal) {
        // console.log('came in to save file')
        fs.writeFileSync(localDataPath, JSON.stringify(dataToSend))
    }

    return dataToSend
}

export async function getStaticProps(ctx) {
    const {
        product,
        variationsAttrs,
        addOnProducts,
        multiTouchProducts,
        productCategories,
        productImages,
        variations,
        fields,
        slug,
        templateIndustries,
        notFound,
    } = await getData(ctx)
    const GeneralAPI = (await import('../../apis/GeneralAPI')).GeneralAPI
    const { acf: reviewsACF = {} } =
        first(await GeneralAPI.getPageBySlug('reviews')) || {}
    const reviews = reviewsACF?.reviews?.length > 0 ? reviewsACF.reviews : []

    if (notFound) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            product,
            variationsAttrs,
            addOnProducts,
            multiTouchProducts,
            productCategories,
            productImages,
            variations,
            fields,
            slug,
            templateIndustries,
            reviews,
        },
        revalidate: 10, // In seconds
    }
    // }
}

export async function getStaticPaths() {
    if (shouldLoadFromLocal) {
        // Return a limited set of paths for development
        return {
            paths: getHrefsFromNavigationsForPaths(),
            fallback: false,
        }
    }

    const allProducts = []

    const ProductAPI = (await import('../../apis/server/ProductAPI')).ProductAPI

    const { data: categories } = await ProductAPI.getProductCategory()
    const { id: categoryId } = first(categories)

    const { data: services } = await ProductAPI.getServicesCategory()
    const { id: servicesId } = first(services)

    let { data } = await ProductAPI.getProductsByCategory(
        `${categoryId},${servicesId}`,
    ) // this can fetch multiple too

    data.forEach((product) => {
        allProducts.push({
            params: {
                slug: product.slug,
            },
        })
    })

    return {
        paths: allProducts,
        fallback: 'blocking',
    }
}
